<template>
  <div>
    <van-nav-bar
      title="我的推广链接"
      left-text=""
      left-arrow
      @click-left="$router.push('/member/agency')"

    />
    <div style="">
      <p class="agency">方法一：扫描二维码</p>
      <van-row>
        <van-col span="6"></van-col>
        <van-col span="12">
          <div id="qrcode" class="agency_qrcode"></div>
        </van-col>
        <van-col span="6"></van-col>
      </van-row>
      <p style="text-align: center">我的二维码</p>
      <div class="agency">
        <p style="line-height: 0px">方法二：点击链接注册</p>
        <p style="color: grey">{{ agencyUrl }}</p>
        <van-button
          size="small"
          round
          type="danger"
          block
          @click="handleCopy"
          style="color: #ffffff"
          >复制链接</van-button
        >
        <p>
          方法三：注册页面输入推广码 <br /><span style="color: grey">{{
            urlCode
          }}</span>
        </p>
        <p style="color: grey"></p>
        <van-button
          size="small"
          round
          type="danger"
          block
          @click="qrCodeCopy"
          style="color: #ffffff"
          >复制推广码</van-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
export default {
  name: "AgencyLink",
  data() {
    return {
      agencyUrl: "",
      Width: "",
      urlCode: "",
    };
  },
  methods: {
    isLogin() {
      let that = this;
      if (!that.$store.state.loginType) {
        that.$router.push("/login");
      }
    },
    qrcode(width, url) {
      let qrcode = new QRCode("qrcode", {
        width: width,
        height: width,
        text: url, // 二维码地址
      });
    },
    getAgencyUrl(width) {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "agent_qrcode",
            token: sessionStorage.getItem("token"),
          },
        })
        .then(function (res) {
          let resData = res.data;
          if (res.data.code == 1) {
            that.agencyUrl = resData.data;
            that.urlCode = that.agencyUrl.split("=")[1];
            that.qrcode(width, that.agencyUrl);
          } else if (res.data.code == 0) {
            that.$toast.fail(res.data.msg);
          }
        })
        .catch(() => {
          that.$toast.fail(that.$NoNetworkErrorMsg);
        });
    },
    getWidth() {
      let width = window.innerWidth / 2;
      this.getAgencyUrl(width);
    },
    handleCopy() {
      let url = this.agencyUrl;
      let oInput = document.createElement("input");
      oInput.value = url;
      document.body.appendChild(oInput);
      oInput.select();
      document.execCommand("Copy");
      this.$toast.success({
        message: "复制成功",
      });
      oInput.remove();
    },
    qrCodeCopy() {
      let oInput = document.createElement("input");
      oInput.value = this.urlCode;
      document.body.appendChild(oInput);
      oInput.select();
      document.execCommand("Copy");
      this.$toast.success({
        message: "复制成功",
      });
      oInput.remove();
    },
  },
  mounted: function () {
    this.isLogin();
    this.getWidth();
  },
};
</script>

<style scoped>
.navStyles {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
}
.agency {
  margin-top: 15px;
  padding-left: 15px;
  padding-right: 15px;
  text-align: left;
  font-size: 13px;
  font-weight: bold;
}
.agency_qrcode {
  width: 100%;
  text-align: center;
  padding: 10px;
}
.qrCodeCopy {
  width: 90%;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/components/AgencyLink.vue